import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';

export interface ArrowNewIconProps extends NewIconProps {
  className?: string;
  color?: string;
  direction?: 'left' | 'right' | 'up' | 'down';
}

export const PaginationArrow = ({
  className,
  color = Color.Gray600,
  direction = 'left',
  opacity = 1.0,
}: ArrowNewIconProps) => {
  let rotate = 0;

  if (direction === 'up') {
    rotate = 90;
  } else if (direction === 'right') {
    rotate = 180;
  } else if (direction === 'down') {
    rotate = 270;
  }
  return (
    <Icon
      className={twMerge(`size-[25px]`, className)}
      color={color}
      opacity={opacity}
      style={{
        transform: `rotate(${rotate}deg)`,
      }}
    />
  );
};

const Icon = ({
  className,
  color,
  opacity = 1,
  style,
}: {
  className?: string;
  style?: CSSProperties;
} & NewIconProps) => (
  <svg
    className={className}
    style={style}
    width="100%"
    height="100%"
    opacity={opacity}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M19.21 8L11 16.21L19.21 24.41L20.62 23L13.83 16.21L20.62 9.41L19.21 8Z" fill={color} />
  </svg>
);
